import { Box, Icon } from "@outschool/backpack";
import { faCheck } from "@outschool/icons";
import { Space } from "@outschool/ui-legacy-component-library";
// This file is not yet translated.
/* eslint-disable i18next/no-literal-string */
import React from "react";

type SuccessWithMessageProps = React.PropsWithChildren<{}>;

export default function SuccessWithMessage({
  children
}: SuccessWithMessageProps) {
  return (
    <Box
      flex
      sx={{
        flexDirection: "row",
        alignItems: "center"
      }}
    >
      <Icon
        sx={{
          color: "#29a877",
          fontSize: "3em"
        }}
        icon={faCheck}
      />{" "}
      <Space x="small" />
      <Box>{children}</Box>
    </Box>
  );
}
